import { ImageProps } from "./image-props";

export const AssigneeJane24Image = (props: ImageProps) => {
    return (
        <img
            height={24}
            width={24}
            alt={props.alt}
            src="https://wac-cdn.atlassian.com/dam/jcr:72bf62eb-6f47-46d4-a915-e68903b6ebb7/illustrations-meeples-Simplified%20Meeples-Tori.svg"
            data-testid={props["data-testid"]}
            className={props.className}
        />
    );
};
